import { LOCATION_POINT_TYPE } from '@location/constants';
import getType from '../getters/getType';

function isFromSearchArea(point) {
  return getType(point) === LOCATION_POINT_TYPE.SEARCH_AREA;
}

export default isFromSearchArea;
